// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;

import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [11,[2]],
		"/(app)/account/ai-tools": [12,[2,3]],
		"/(app)/account/appearance": [13,[2,3]],
		"/(app)/account/applications": [14,[2,3]],
		"/(app)/account/external-logins": [15,[2,3]],
		"/(app)/account/manage": [16,[2,3]],
		"/(app)/account/notifications": [17,[2,3]],
		"/(app)/account/security": [18,[2,3]],
		"/(app)/account/sessions": [19,[2,3]],
		"/(app)/account/verify": [20,[2,3]],
		"/(app)/event": [21,[2]],
		"/(app)/event/by-ref/[referenceId]": [24,[2]],
		"/(app)/event/[slug=savedview]": [23,[2]],
		"/(app)/event/[eventId=objectid]": [22,[2]],
		"/(app)/exie": [25,[2]],
		"/(auth)/forgot-password": [69,[10]],
		"/(auth)/login": [70,[10]],
		"/(auth)/oauth/authorize": [71,[10]],
		"/(app)/organization/add": [32,[2,4]],
		"/(app)/organization/list": [33,[2,4]],
		"/(app)/organization/[organizationId]/billing": [26,[2,4,5]],
		"/(app)/organization/[organizationId]/features": [27,[2,4,5]],
		"/(app)/organization/[organizationId]/manage": [28,[2,4,5]],
		"/(app)/organization/[organizationId]/projects": [29,[2,4,5]],
		"/(app)/organization/[organizationId]/usage": [30,[2,4,5]],
		"/(app)/organization/[organizationId]/users": [31,[2,4,5]],
		"/(app)/payment/[id]": [34],
		"/(app)/project/add": [45,[2,6]],
		"/(app)/project/list": [46,[2,6]],
		"/(app)/project/[projectId]/api-keys": [35,[2,6,7]],
		"/(app)/project/[projectId]/configuration-values": [36,[2,6,7]],
		"/(app)/project/[projectId]/configure": [37,[2,6,7]],
		"/(app)/project/[projectId]/integrations": [38,[2,6,7]],
		"/(app)/project/[projectId]/manage": [39,[2,6,7]],
		"/(app)/project/[projectId]/settings": [40,[2,6,7]],
		"/(app)/project/[projectId]/source-maps": [41,[2,6,7]],
		"/(app)/project/[projectId]/stacks": [42,[2,6,7]],
		"/(app)/project/[projectId]/stacks/[stackId]": [43,[2,6,7]],
		"/(app)/project/[projectId]/usage": [44,[2,6,7]],
		"/(auth)/reset-password/[token]": [72,[10]],
		"/(app)/sessions": [47,[2]],
		"/(app)/sessions/[slug=savedview]": [48,[2]],
		"/(auth)/signup": [73,[10]],
		"/(app)/stack": [49,[2]],
		"/(app)/stack/[stackId=objectid]": [51,[2]],
		"/(app)/stack/[slug=savedview]": [50,[2]],
		"/(app)/stack/[stackId=objectid]/event/[eventId=objectid]": [52,[2]],
		"/status": [74],
		"/(app)/stream": [53,[2]],
		"/(app)/system": [54,[2,8]],
		"/(app)/system/actions/[[category]]": [55,[2,8]],
		"/(app)/system/elasticsearch": [56,[2,8,9]],
		"/(app)/system/elasticsearch/backups": [57,[2,8,9]],
		"/(app)/system/elasticsearch/indices": [58,[2,8,9]],
		"/(app)/system/elasticsearch/overview": [59,[2,8,9]],
		"/(app)/system/exie": [60,[2,8]],
		"/(app)/system/migrations": [61,[2,8]],
		"/(app)/system/notifications": [62,[2,8]],
		"/(app)/system/oauth-applications": [63,[2,8]],
		"/(app)/system/oauth-applications/new": [65,[2,8]],
		"/(app)/system/oauth-applications/[id=objectid]": [64,[2,8]],
		"/(app)/system/overview": [66,[2,8]],
		"/(app)/system/saved-views": [67,[2,8]],
		"/(app)/system/settings": [68,[2,8]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);